import { api } from "../api";

/**
 * managerFindAllListResponse - Function that finds on database all managers as select list   
 *`/managers/list 
 * method GET 
 * @async-function
 */
const managerFindAllListResponse = async (token: string) => {
    const response = await api.get(
        `/managers/list`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default managerFindAllListResponse;